module.exports = __webpack_public_path__ + "img/front_buttons_quantity.c84c6710.png";